import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Checkbox from "react-icheck/lib/Checkbox";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";
import checkStyles from "../../../styles/icheck/square/blue.css";

class SubscriptionSettings extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this
      .props
      .userSettingsActions
      .toggleCheckbox(this.props.userSettings.data.profileInfo.subscriptionIds, event.target.name, event.target.checked);
  }

  handleSubmit() {
    this
      .props
      .userSettingsActions
      .submitSubscriptions(this.props.userSettings.data.profileInfo.subscriptionIds);
  }

  createNewsletterName(name) {
    // Pluralize the newsletter names if found in the lookup
    const lookups = {
      "alert": "Alerts",
      "newsletter": "Newsletters",
    };

    const newName = lookups[name] || name;

    return newName.toUpperCase();
  }

  render() {
    return (
      <div className={classNames(styles.infoWrapper, styles.marginTop20)}>
        <div className={styles.blueHeading}>
          EMAIL SUBSCRIPTIONS
        </div>

        {Object.keys(this.props.userSettings.data.subscriptions).map((key, kIndex) => {
          const subscriptions = this.props.userSettings.data.subscriptions[key];

          return (
            <Row key={kIndex} className={styles.marginTop20}>
              <Col lg="2" sm="12" xs="12" className={styles.muted}>{this.createNewsletterName(key)}</Col>
              <Col lg="10" sm="12" xs="12">
                <Row className={styles.checkboxContainer}>
                  {subscriptions.map((subscription, sIndex) => {
                    return (
                      <Col key={sIndex} lg="6" sm="12" xs="12">
                        <div className={styles.checkboxes}>
                          <Checkbox onChange={this.handleChange} name={subscription.id} checkboxClass={checkStyles["icheckbox_square-blue"]} checkedClass={checkStyles.checked} label={subscription.name} checked={this.props.userSettings.data.profileInfo.subscriptionIds.indexOf(subscription.id) >= 0} />
                        </div>
                      </Col>
                    );
                  }) }
                </Row>
              </Col>
            </Row>
          );
        }) }

        <div className={styles.textCenter}>
          <button onClick={this.handleSubmit} type="button" className={classNames(styles.marginTop40, styles.blueButton1, styles.mobileBlock, styles.saveSubscriptionsButton)}>
            Save changes
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionSettings);



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/SubscriptionSettings.js